module.exports = __webpack_public_path__ + "static/media/logo.7ea4971c.png";